import { SectionService } from "@/core/services/section.service";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'form-layout',
    templateUrl: './form-layout.component.html',
    styleUrls: ['./form-layout.component.scss']
})
export class FormLayoutComponent implements OnInit {
    @Input() public showSave: boolean = true;
    @Input() public showNext: boolean | undefined;
    @Input() public showBack: boolean | undefined;
    @Input() public showVorabCheck: boolean = false;

    @Output('onSave') onSaveEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output('onNext') onNextEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output('onBack') onBackEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output('onVorabCheck') onVorabCheckEvent: EventEmitter<void> = new EventEmitter<void>();

    constructor(protected sectionService: SectionService, protected router: Router) {
        //
    }

    ngOnInit(): void {
        if (this.showNext === undefined) {
            this.showNext = this.sectionService.canGoNext(this.router);
            this.router.events.subscribe(() => {
                this.showNext = this.sectionService.canGoNext(this.router);
            });
        }

        if (this.showBack === undefined) {
            this.showBack = this.sectionService.canGoBack(this.router);
            this.router.events.subscribe(() => {
                this.showBack = this.sectionService.canGoBack(this.router);
            });
        }
    }

    protected dispatch(type: string): void
    {
        switch(type) {
            case 'save':
                this.onSaveEvent.emit();
                break;
            case 'next':
                this.onNextEvent.emit();
                break;
            case 'back':
                this.onBackEvent.emit();
                break;
            case 'vorabCheck':
                this.onVorabCheckEvent.emit();
                break;
        }
    }
}
